import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-employee-detail-modal',
  templateUrl: './employee-detail-modal.component.html',
  styleUrls: ['./employee-detail-modal.component.css']
})
export class EmployeeDetailModalComponent implements OnInit {
  
  @Input() employeeDetail:any;
  @Output() closeModal = new EventEmitter<any>();

  constructor(){}

  ngOnInit(): void {
  }

   onCloseModal(){
    this.closeModal.emit();
  }

}
